import React, { useState, useContext } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../SelectValue/FormikControl";
import Button from "../SelectValue/Button";
import { Link, useNavigate } from "react-router-dom";
import Loading from "../SelectValue/Loading";
import postService from "../../Services/post-service";
import Logo from "../../Assets/images/Zlogo.png";
import cookie from "react-cookies";
import { toast } from "react-toastify";
import { UserContext } from "../../Context/UserContext";

function Loginform() {
  const [loading, setLoading] = useState(false);
  const { login } = useContext(UserContext);
  const navigate = useNavigate();

  const initialValues = {
    email: "",
    password: "",
  };
  const validationSchema = Yup.object({
    email: Yup.string().email().required("Please Enter your Email"),
    password: Yup.string().required("Please Enter your password"),
  });
  const onSubmit = (values) => {
    setLoading(true);
    const { email, password } = values;
    postService.userLogin(email, password).then(
      (response) => {
        setLoading(false);
        if (response.data?.statusCode === 200) {
          const token = response.data.data.token;
          // Store virtual account details in local storage
          localStorage.setItem(
            "virtualAccountNumber",
            response.data.data.virtualAccountNumber,
          );
          localStorage.setItem(
            "virtualAccountName",
            response.data.data.virtualAccountName,
          );
          localStorage.setItem(
            "walletNumber",
            response.data.data.walletNumber || "",
          );
          toast.success("Login successful", { autoClose: 1000 });
          // Update context and navigate to dashboard
          setTimeout(() => {
            login(token, response.data.data);
            navigate("/dashboard");
          }, 1000);
          return;
        }

        if (response.data?.statusCode == 201) {
          sessionStorage.setItem("sEmail", email);
          sessionStorage.setItem("sPassword", password);
          sessionStorage.setItem("authSource", "login");
          toast.info(
            response.data?.description ||
            "Please verify your account. An OTP has been sent to your email.",
            { autoClose: 2000 }
          );
          setTimeout(() => {
            navigate("/verifyaccount");
          }, 1000);
          return;
        }

        toast.error(response.data?.description || "Login failed");
      },
      (error) => {
        setLoading(false);
        if (
          error.response?.data?.statusCode == 201
        ) {
          sessionStorage.setItem("sEmail", email);
          sessionStorage.setItem("sPassword", password);
          sessionStorage.setItem("authSource", "login");
          toast.info(
            error.response?.data?.description ||
            "Please verify your account. An OTP has been sent to your email.",
            { autoClose: 2000 }
          );
          setTimeout(() => {
            navigate("/verifyaccount");
          }, 1000);
          return;
        }
        const errorMessage =
          error.response?.data?.description ||
          "Server is currently unavailable. Please try again later.";
        return toast.error(errorMessage, { autoClose: 1000 }, {
          position: toast.POSITION.TOP_RIGHT,
        });
      },
    );
  };

  return (
    <div className=" ">
      <Loading open={loading} />
      <img
        src={Logo}
        width="152"
        height="40"
        className=" mx-auto mb-5 "
        alt=" logo"
      />
      <div className=" bg-white shadow-lg p-5 md:p-10 rounded-[16px]">
        <p className=" mt-6 text-[18px] text-back-color2 mb-5 md:text-[40px] font-[500]">
          Login to your account
        </p>

        <div className="  mt-5">
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {(formik) => (
              <Form>
                <FormikControl
                  control="input"
                  label="Email address"
                  name="email"
                />

                <FormikControl
                  control="password"
                  label="Password"
                  name="password"
                />
                <div className=" flex justify-end mt-3 mb-7">
                  <Link to="/forgetpassword">
                    <span className=" text-primary-color">
                      Forgot password?
                    </span>
                  </Link>
                </div>
                <div className=" grid grid-cols-1 mb-5 mt-6">
                  <Button name="Login" />
                </div>
                <div className=" mt-4">
                  <p className=" font-[500] text-center">
                    Don’t have an account?{" "}
                    <Link to="/sign-up" className=" text-primary-color">
                      Create account
                    </Link>{" "}
                  </p>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
}

export default Loginform;
